import TimeUtils from "../utils/time.js";
import StringUtils from "../utils/string.js";
import Config from "../../../resources/config.js";
import ufs from "../data/ufs.js";

const $ = window["$"];
let tooltipList = [];
let popoverList = [];

function updateWrapBoxes() {
    $(".wrap-box").each(function (index, item) {
        updateWrapBox(item);
    });
}

function updateWrapBox(item) {
    let $box = $(item);
    if ($box.is('.unclamp')) {
        return;
    }

    let p = $box.children("p").eq(0)[0];
    let $label = $box.children("label");

    if (p.scrollHeight > p.clientHeight) {
        $label.show();
    } else {
        if ($box.is('.unclamp')) {
            $label.hide();
            $box.removeClass("unclamp");
        } else {
            $label.hide();
        }
    }
}

$(document).on('click', '.wrap-box label', function () {
    let $wrapBox = $(this).closest('.wrap-box');
    $wrapBox.toggleClass("unclamp");

    if (!$wrapBox.is('.unclamp')) {
        updateWrapBox($wrapBox);
        return;
    }
});

$(window).on('resize', updateWrapBoxes);

export default {
    methods: {

        getImageURL(file) {
            return `${Config.assetsHost}/${file}`;
        },

        getVideoURL(video) {
            return `${Config.videosHost}/${video.path}/${video.config.video_file}.m3u8`;
        },

        getVideoThumbnailURL(video) {
            if (video.type === 1) {
                let youtube_video_id = video.path.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
                return `http://img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg`;
            } else {
                return `${Config.videosHost}/${video.path}/thumbnail.jpeg`;
            }
        },

        getCourseThumbnailURL(course) {
            if (course.plan === 'Free') {
                return course.path;
            } else {
                return `${Config.coursesHost}/${course.path}/thumbnail.jpeg`;
            }
        },

        getCourseMentorshipThumbnailURL(course) {
            return `${Config.coursesHost}/${course.path}/thumbnail_mentorship.jpeg`;
        },

        getMentorshipThumbnailURL(mentorship) {
            return `${Config.coursesHost}/${mentorship.course_path}/mentorias/${mentorship.path}/thumbnail.jpeg`;
        },

        getMentorshipURL(mentorship) {
            return `${Config.coursesHost}/${mentorship.course_path}/mentorias/${mentorship.path}/${mentorship.config.video_file}.m3u8`;
        },

        getCourseClassURL(course, classObj) {
            return `${Config.coursesHost}/${course.config.path}/${classObj.config.path}.m3u8`;
        },

        formatPlural(count, singular, plural) {
            if (count === 1) {
                return count + " " + singular;
            } else {
                return count + " " + plural;
            }
        },

        validateName(name) {
            if (!name || name.trim().length < 10) {
                return false;
            }
            return true;
        },

        validateCPFCNPJ(cpf_cnpj) {
            const cleanDocument = cpf_cnpj.replace(/\D/g, '');
            if (cleanDocument.length === 11) {
                return this.validateCPF(cpf_cnpj);
            } else if (cleanDocument.length === 14) {
                return this.validateCNPJ(cpf_cnpj);
            } else {
                return false;
            }
        },

        validateCPF(cpf) {
            // Check if the input consists of only numbers or a properly formatted CPF (XXX.XXX.XXX-XX)
            if (!/^\d{11}$/.test(cpf) && !/^\d{3}(\.\d{3}){2}-\d{2}$/.test(cpf)) {
                return false;
            }

            cpf = cpf.replace(/\D/g, ''); // Remove any non-numeric characters (dots, hyphens)

            // Check if CPF has 11 digits and is not composed of all identical digits
            if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

            // Function to calculate the verification digit
            const calcDigit = (cpf, pos) => {
                let sum = 0, multiplier = pos;
                for (let i = 0; i < pos - 1; i++) sum += cpf[i] * multiplier--;
                return (sum % 11 < 2) ? 0 : 11 - (sum % 11);
            };

            // Validate the two verification digits
            if (parseInt(cpf[9]) !== calcDigit(cpf, 10) || parseInt(cpf[10]) !== calcDigit(cpf, 11)) return false;

            return true;
        },

        validateCNPJ(cnpj) {
            // Check if the input is either numeric (14 digits) or in the correct format (XX.XXX.XXX/XXXX-XX)
            if (!/^\d{14}$/.test(cnpj) && !/^\d{2}(\.\d{3}){2}\/\d{4}-\d{2}$/.test(cnpj)) {
                return false;
            }

            cnpj = cnpj.replace(/\D/g, ''); // Remove non-numeric characters (dots, slashes, hyphens)

            // Check if CNPJ has 14 digits and is not composed of all identical digits
            if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

            // Function to calculate the verification digit
            const calcDigit = (cnpj, weights) => {
                let sum = 0;
                for (let i = 0; i < weights.length; i++) {
                    sum += cnpj[i] * weights[i];
                }
                const remainder = sum % 11;
                return remainder < 2 ? 0 : 11 - remainder;
            };

            // Weights for the first and second check digits
            const firstDigitWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            const secondDigitWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            // Validate the two check digits
            const firstCheckDigit = calcDigit(cnpj, firstDigitWeights);
            const secondCheckDigit = calcDigit(cnpj, secondDigitWeights);

            if (parseInt(cnpj[12]) !== firstCheckDigit || parseInt(cnpj[13]) !== secondCheckDigit) return false;

            return true;
        },

        validateAddress(address) {
            if (!address || address.trim().length < 5) {
                return false;
            }
            return true;
        },

        validateAddressNumber(address_number) {
            if (!address_number || address_number.trim().length < 1 || Number(address_number) < 0) {
                return false;
            }
            return true;
        },

        validateNeighborhood(neighborhood) {
            if (!neighborhood || neighborhood.trim().length < 3) {
                return false;
            }
            return true;
        },

        validateCEP(cep) {
            if (!/^\d{8}$/.test(cep) && !/^\d{5}-\d{3}$/.test(cep)) {
                return false;
            }

            if (/^\d{5}-\d{3}$/.test(cep)) {
                return true;
            }

            return true;
        },

        validatePhone(phoneNumber) {
            // Regex for validating phone numbers
            const regex = /^(\(\d+\))?[\d\s\-]+(\d)$/;

            // Test if the input phone number matches the regex
            if (!regex.test(phoneNumber)) {
                return false;
            }

            phoneNumber = '+' + intl.getSelectedCountryData().dialCode + phoneNumber;

            return intlTelInputUtils.isValidNumber(
                phoneNumber,
                null,
                intlTelInputUtils.numberFormat.INTERNATIONAL
            );
        },

        formatElapsedTime(time) {

            let seconds = Math.floor((new Date() - time) / 1000);
            let intervalType;
            if (seconds === 0) {
                return 'Agora mesmo';
            }

            let interval = Math.floor(seconds / 31536000);
            if (interval >= 1) {
                intervalType = 'anos';
            } else {
                interval = Math.floor(seconds / 2592000);
                if (interval >= 1) {
                    if (interval > 1) {
                        intervalType = 'meses';
                    } else {
                        intervalType = 'mês';
                    }
                } else {
                    interval = Math.floor(seconds / 86400);
                    if (interval >= 1) {
                        if (interval > 1) {
                            intervalType = 'dias';
                        } else {
                            intervalType = 'dia';
                        }
                    } else {
                        interval = Math.floor(seconds / 3600);
                        if (interval >= 1) {
                            if (interval > 1) {
                                intervalType = 'horas';
                            } else {
                                intervalType = 'hora';
                            }
                        } else {
                            interval = Math.floor(seconds / 60);
                            if (interval >= 1) {
                                if (interval > 1) {
                                    intervalType = 'minutos';
                                } else {
                                    intervalType = 'minuto';
                                }
                            } else {
                                interval = seconds;
                                if (interval > 1) {
                                    intervalType = 'segundos';
                                } else {
                                    intervalType = 'segundo';
                                }
                            }
                        }
                    }
                }
            }
            return interval + ' ' + intervalType + ' atrás';
        },

        formatDuration(loanDurationInSeconds) {
            return TimeUtils.formatDuration(loanDurationInSeconds);
        },

        formatTimestamp(timestamp) {
            let date = new Date(timestamp);
            return date.toLocaleDateString("pt-BR") + " às " + date.toLocaleTimeString("pt-BR")
        },

        // formatTimestamp(timestamp) {
        //     const date = new Date(timestamp);

        //     // Formato de data (DD/MM/AAAA)
        //     const datePart = date.toLocaleDateString("pt-BR");

        //     // Formato de hora, minuto e segundo (HH:MM:SS) - Usando hour12: false para 24h
        //     const timePart = date.toLocaleTimeString("pt-BR", { hour12: false });

        //     // Milissegundos (Deve ser formatado com 3 dgitos, ex: 50 -> "050")
        //     const ms = String(date.getMilliseconds()).padStart(3, '0');

        //     // Junta tudo: DD/MM/AAAA HH:MM:SS.mmm
        //     return `${datePart} ${timePart}.${ms}`;
        // },

        formatMultilineText(text) {
            return $('<div/>').text(text).html().replace(new RegExp('\r?\n', 'g'), '<br />');
        },

        formatAddress(address, number, complement, neighborhood) {
            let addr = `${address}, ${number}`;
            if (!StringUtils.isEmpty(complement)) {
                addr += ` - ${complement}`;
            }
            addr += `, ${neighborhood}`;
            return addr;
        },


        formatCPFCNPJ(cpf_cnpj) {
            if (cpf_cnpj.length <= 11) {
                return cpf_cnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
            } else {
                return cpf_cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
            }
        },

        formatPhone(phoneNumber, format) {
            if (format === undefined || format === null) {
                format = intlTelInputUtils.numberFormat.INTERNATIONAL;
            }
            return intlTelInputUtils.formatNumber(phoneNumber, null, format);
        },

        formatCity(uf, city) {
            let municipiosData = ufs;
            if (municipiosData[uf]) {
                let municipio = municipiosData[uf].municipios.find(m => m.codigo_ibge === Number(city));

                if (municipio) {
                    return municipio.nome;
                }
            }
            return null;
        },

        formatZipCode(zipCode) {
            zipCode = zipCode.replace(/\D/g, '');

            if (zipCode.length === 8) {
                return zipCode.replace(/(\d{5})(\d{3})/, '$1-$2');
            }

            return zipCode;
        },


        dateWithTimeZone(timeZone, year, month, day, hour, minute, second) {
            let date = new Date(Date.UTC(year, month, day, hour, minute, second));

            let utcDate = new Date(date.toLocaleString('en-US', { timeZone: "UTC" }));
            let tzDate = new Date(date.toLocaleString('en-US', { timeZone: timeZone }));
            let offset = utcDate.getTime() - tzDate.getTime();

            date.setTime(date.getTime() + offset);

            return date;
        },

        formatAnnualizedReturn(loanAmount, loanInterest, loanDurationInSeconds) {
            if (!loanAmount || !loanInterest || !loanDurationInSeconds) {
                return "-";
            }

            loanAmount = Number(loanAmount);
            loanInterest = Number(loanInterest);
            loanDurationInSeconds = Number(loanDurationInSeconds);

            let loanDays = loanDurationInSeconds / (24 * 3600);
            let totalReturn = (loanAmount + loanInterest) / loanAmount;
            let arr = Math.pow(totalReturn, (365 / loanDays)) - 1;

            return parseFloat(arr * 100).toFixed(4) + "%";
        },

        formatTotalAmount(loan) {
            if (!loan || !loan.amount || !loan.interest) {
                return "-";
            }

            return this.formatPrice(BigInt(loan.amount) + BigInt(loan.interest));
        },

        formatNumber(number) {
            return intlTelInputUtils.formatNumber(number, null, intlTelInputUtils.numberFormat.INTERNATIONAL)
        },

        getRatingStars(rating) {
            let ret = [];
            for (let i = 0; i < 5; i++) {
                ret.push({ id: i, class: 'fa-regular fa-star' });
            }
            if (rating >= 0.5 && rating < 1) {
                ret[0].class = 'fa-regular fa-star-half-stroke';
            } else if (rating >= 1 && rating < 1.5) {
                ret[0].class = 'fa-solid fa-star';
            } else if (rating >= 1.5 && rating < 2) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-regular fa-star-half-stroke';
            } else if (rating >= 2 && rating < 2.5) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
            } else if (rating >= 2.5 && rating < 3) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
                ret[2].class = 'fa-regular fa-star-half-stroke';
            } else if (rating >= 3 && rating < 3.5) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
                ret[2].class = 'fa-solid fa-star';
            } else if (rating >= 3.5 && rating < 4) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
                ret[2].class = 'fa-solid fa-star';
                ret[3].class = 'fa-regular fa-star-half-stroke';
            } else if (rating >= 4 && rating < 4.5) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
                ret[2].class = 'fa-solid fa-star';
                ret[3].class = 'fa-solid fa-star';
            } else if (rating >= 4.5 && rating < 5) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
                ret[2].class = 'fa-solid fa-star';
                ret[3].class = 'fa-solid fa-star';
                ret[4].class = 'fa-regular fa-star-half-stroke';
            } else if (rating >= 5) {
                ret[0].class = 'fa-solid fa-star';
                ret[1].class = 'fa-solid fa-star';
                ret[2].class = 'fa-solid fa-star';
                ret[3].class = 'fa-solid fa-star';
                ret[4].class = 'fa-solid fa-star';
            }

            return ret;
        },

        buildSessionLink() {
            return "Sua sessão expirou.<br/><a onclick='window.global.popupWindow(\"" + Config.apiHost + "/auth/google/assistant?popup=true\",\"_blank\",window, 600, 400)' target='_blank' class='link'> Clique aqui para entrar novamente</a>";
        },

        formatClientStatus(status) {
            switch (status) {
                case 1:
                    return "Em análise";
                case 2:
                    return "Ativo";
                case 3:
                    return "Inativo";
                default:
                    return "Desconhecido";
            }
        },

        formatProjectStatus(status) {
            switch (status) {
                case 1:
                    return "Em análise";
                case 2:
                    return "Ativo";
                case 3:
                    return "Desativado";
                case 4:
                    return "Encerrado";
                default:
                    return "Desconhecido";
            }
        },

        formatProposalStatus(proposal) {
            if (proposal.status === 1) { // under review
                if (proposal.project_status === 3) { // inactive
                    return "Proposta desativada";
                } else if (proposal.project_status === 4) { // closed
                    if (!proposal.released) {
                        return "Cliente não interessou";
                    } else {
                        return "Cliente interessado";
                    }
                } else { // under review, active
                    return "Proposta enviada";
                }
            } else if (proposal.status === 2) { //active
                if (proposal.project_status === 3) { // inactive
                    return "Proposta desativada";
                } else if (proposal.project_status === 4) { // closed
                    if (!proposal.released) {
                        return "Cliente não interessou";
                    } else {
                        return "Cliente interessado";
                    }
                } else { // under review, active
                    if (proposal.released) {
                        return "Cliente interessado";
                    } else {
                        return "Proposta enviada";
                    }
                }
            }
            else if (proposal.status === 3) { // inactive
                return "Proposta desativada";
            } else {
                return "Desconhecido";
            }

        },


        getProposalTextClass(proposal) {
            if (proposal.status === 1) { // under review
                if (proposal.project_status === 3) { // inactive
                    return "text-danger";
                } else if (proposal.project_status === 4) { // closed
                    return "text-orange";
                } else { // under review, active
                    return "text-warning";
                }
            } else if (proposal.status === 2) { //active
                if (proposal.project_status === 3) { // inactive
                    return "text-danger";
                } else if (proposal.project_status === 4) { // closed
                    if (!proposal.released) {
                        return "text-orange";
                    } else {
                        return "text-success";
                    }
                } else { // under review, active
                    if (proposal.released) {
                        return "text-success";
                    } else {
                        return "text-warning";
                    }
                }
            }
            else if (proposal.status === 3) { // inactive
                return "text-danger";
            } else {
                return "text-dark";
            }
        },

        getProposalAcceptanceClass(accepted) {
            if (accepted) {
                return "text-success";
            } else {
                return "text-warning";
            }
        },

        getProposalSentClass(sent) {
            if (sent) {
                return "text-success";
            } else {
                return "text-danger";
            }
        },

        getBtnStatusClass(status) {
            switch (status) {
                case 1:
                    return "bg-warning";
                case 2:
                    return "bg-success";
                case 3:
                    return "bg-danger";
                case 4:
                    return "bg-orange";
                default:
                    return "bg-dark";
            }
        },

        getTextStatusClass(status) {
            switch (status) {
                case 1:
                    return "text-warning";
                case 2:
                    return "text-success";
                case 3:
                    return "text-danger";
                case 4:
                    return "text-orange";
                default:
                    return "text-dark";
            }
        },

        handleAPIError(error, sourcePage) {
            console.log(error);
            if (error.status === 401) {
                window.location = Config.loginPage + (sourcePage ? "?next=" + sourcePage : "");
            } else if (error.errorCode === "ASSISTANT_NOT_FOUND") {
                window.location = Config.profilePage + "?nome=" + error.errorData.name + "&email=" + error.errorData.email_address;
            } else {
                this.$store.commit("setError", error);
                this.$store.commit("setLoading", false);
            }
        },

        showError(err) {
            console.log(err);
            let error;
            if (err.data && err.data.data && err.data.data.message) {
                error = err.data.data.message;
            } else if (err.message) {
                error = err.message;
            } else {
                error = err;
            }

            this.$store.commit("setLoading", false);

            $("#errorMsg").html(this.formatMultilineText(error));
            $("#errorModal").modal("show");

        },

        showSuccess(msg) {
            $("#successMsg").html(this.formatMultilineText(msg));
            $("#successModal").modal("show");
        },

        showConfirmation(title, confirmationMessage, confirmButtonTitle, confirmAction, successMessage, errorMessage) {
            let $confirmModal = $("#confirmModal");
            $confirmModal.find("[data-title]").text(title);
            $confirmModal.find("[data-msg]").text(confirmationMessage);

            this.showModal($confirmModal, function () { }, confirmButtonTitle, confirmAction, successMessage, errorMessage);
        },

        showSubscribeModal(title, body, init) {
            let $modal = $('#subscribeModal');
            let $btnConfirmAction = $modal.find('[data-confirm]');

            $modal.find('[data-title]').text(title);
            $modal.find('[data-body]').html(body);

            $modal.data('initFunction', function () {
                $('html').addClass('noscroll');
            });

            $modal.off().on('hidden.bs.modal', function () {
                $('html').removeClass('noscroll');
                $modal.data('initFunction', null);
            });

            if (init) {
                init($modal);
            }

            $modal.modal("show");
        },

        showOfferModal(resource) {
            let $modal = $("#offerModal");

            var timerEl = document.getElementById('modalTimer');
            var countdownEl = document.getElementById('offerCountdown');
            var expiresAt = Date.now() + resource.countdown_ms;
            
            $modal.find('[data-offer-content]').hide();
            $modal.find(`#${resource.offerId}`).show();

            // Timer
            function pad(n) { return n < 10 ? '0' + n : n; }

            let baseURL = window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://www.virtap.com.br';
            let path = '/' + Config.offers[resource.offerId].offerPath;
            let offerUrl = baseURL + `${path}?rsrc=`
                + resource.id
                + "&utm_source=plataforma&utm_medium=assistentes&utm_campaign=oferta-intro-av&utm_content=" + resource.offerId.toLowerCase();
            document.getElementById('offerCta').href = offerUrl;

            function adjust() {
                var diff = expiresAt - Date.now();
                if (diff <= 0) {
                    clearInterval(interval);
                    timerEl.textContent = 'Sua oferta terminou';
                    $("#offerText").remove();
                    countdownEl.style.background = '#444';
                    var cta = document.getElementById('offerCta');
                    $("#expireHint").remove();
                    cta.href = 'https://wa.me/5548988089062?text=Oi%2C%20minha%20oferta%20expirou%20mas%20ainda%20tenho%20interesse';
                    cta.target = '_blank';
                    cta.style.background = '#25d366';
                    cta.innerHTML = '<i class="fa-brands fa-whatsapp"></i> Falar com a Virtap';
                    return;
                }
                var h = Math.floor(diff / 3600000);
                var m = Math.floor((diff % 3600000) / 60000);
                var s = Math.floor((diff % 60000) / 1000);
                timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);



            }

            var interval = setInterval(function () {
                adjust();
            }, 1000);

            $modal.off().on('hidden.bs.modal', function () {
                $('html').removeClass('noscroll');
                clearInterval(interval);
            });
            adjust();

            $modal.modal("show");

        },

        showModal(modal, init, confirmButtonTitle, confirmAction, successMessage, errorMessage, closeAction) {
            let $ctx = this;
            let $modal = $(modal);
            let $modalError = $modal.find('[data-error]')
            let $btnConfirmAction = $modal.find('[data-confirm]');

            $modalError.hide();
            $btnConfirmAction.text(confirmButtonTitle);

            $modal.data('initFunction', function () {
                $('html').addClass('noscroll');
                init($modal);
            });

            $modal.off().on('hidden.bs.modal', function () {
                $('html').removeClass('noscroll');
                $modal.data('initFunction', null);
                if (closeAction) {
                    closeAction();
                }
            });

            $btnConfirmAction.off().on("click", async function () {
                try {
                    $modal
                        .find("input, textarea, button, select, .btn")
                        .addClass("disabled")
                        .prop("disabled", true);

                    $btnConfirmAction.text("Por favor, aguarde...");
                    $modalError.hide();

                    if (await confirmAction()) {
                        $modal.modal("hide");
                        $ctx.showSuccess(successMessage);
                    }
                } catch (error) {
                    console.log(error);
                    if (error.status === 401) {
                        $modalError.html($ctx.buildSessionLink()).show();
                    }
                    else if (error.errorCode === "INVALID_ASSISTANT_STATUS" && error.errorData === 3) {
                        $modalError.html("Seu perfil foi desativado.<br/>Entre em contato com o suporte para maiores informações.").show();
                    }
                    else if (error.errorCode === "MONTHLY_PROPOSALS_EXCEEDED") {
                        $modalError.html("Você excedeu o limite de propostas!").show();
                    }
                    else if (error.errorCode === "FREE_PLAN_NOT_ALLOWED") {
                        $modalError.html("Para enviar propostas, é necessário assinar um plano.").show();
                    }
                    else if (error.errorCode === "EXCLUSIVE_PROJECT") {
                        $modalError.html("Esta oportunidade de trabalho é exclusiva para membros do plano Elite.").show();
                    }
                    else if (error.errorCode === "HIRES_EXCEEDED") {
                        $modalError.html("Limite atingido! Você excedeu o limite de contratações no plano gratuito.<br>Assine o Virtap Club para poder enviar propostas ilimitadas.").show();
                    }
                    else if (error.errorCode === "PROJECT_NOT_FOUND") {
                        $modalError.html("O projeto não está mais disponível.").show();
                    } else {
                        $modalError.html($ctx.formatMultilineText(errorMessage)).show();
                    }
                } finally {
                    $modal
                        .find("input, textarea, button, select, .btn")
                        .removeClass("disabled")
                        .prop("disabled", false);

                    $btnConfirmAction.text(confirmButtonTitle);
                }
            });

            $modal.modal("show");

        },

        hasContactInfo(text) {
            let emailPat = /(\".*\"|[A-Za-z]\w*)@(\[\d{1,3}(\.\d{1,3}){3}]|[A-Za-z]\w*(\.[A-Za-z]\w*)+)/g
            let phonePart = /[0-9\s\-\()]+/g;
            let urlPat = "[A-Za-z]+://[A-Za-z0-9-_]+\\.[A-Za-z0-9-_%&\?\/.=]+";
            let handlePat = /@+/g;

            if (text.match(emailPat)) {
                return true;
            }

            if (text.match(handlePat)) {
                return true;
            }

            let words = text.split(" ");
            if (words) {

                for (let word of words) {
                    if (word.replace(/\D/g, "").length >= 8) {
                        return true;
                    }
                }
            }

            let m = text.match(phonePart);
            if (m) {
                for (let word of m) {
                    if (word.replace(/\D/g, "").length >= 8) {
                        return true;
                    }
                }
            }

            if (text.match(urlPat)) {
                return true;
            }

            return false;
        },

        getCertAVTitle() {
            return 'Profissional certificado em <br/>Assistência Virtual';
        },

        getCertAVDescription() {
            return 'Certificação concedida pela Virtap, referência nacional em formação de Assistentes Virtuais.<br/><br/>Treinamento completo, criado por especialistas com mais de 10 anos de experiência no setor, que reúne tudo o que é essencial para atuar com excelência na área.';
        },

        getCervAPTitle() {
            return 'Profissional certificado em <br/> Assessoria Pessoal';
        },

        getCertAPDescription() {
            return 'Fornecido pela Virtap, este é o treinamento mais completo em Assistência Pessoal do Brasil.<br/><br/> Elaborado por profissionais que acumulam 10 anos de experiência no mercado, capacita o profissional para lidar com demandas reais do dia a dia, com segurança e responsabilidade.';
        },

        initTooltips() {
            tooltipList.forEach((tooltip) => { tooltip.dispose() });
            let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            });

            popoverList.forEach((popover) => { popover.dispose() });
            let popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
            popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {

                popperConfig(defaultBsPopperConfig) {
                    const newPopperConfig = { strategy: 'fixed' }
                    defaultBsPopperConfig.modifiers[0].enabled = false;

                    // use defaultBsPopperConfig if needed...
                    return defaultBsPopperConfig
                }
            }))
        },

        applyTruncation(callback) {
            this.$nextTick(function () {
                setTimeout(updateWrapBoxes, 400);
                if (callback) {
                    setTimeout(callback, 400);
                }
            });;

        },

        populateMunicipios(uf, field) {
            $(field).empty();
            let municipiosData = ufs;
            if (municipiosData[uf]) {
                municipiosData[uf].municipios.forEach(function (municipio) {
                    $(field).append(`<option value="${municipio.codigo_ibge}">${municipio.nome}</option>`);
                });
            }
        },

        calculateCourseProgress(course) {
            let progress = 0;
            let completedClasses = 0;
            let totalClasses = 0;
            if (course) {
                for (let m of course.modules) {
                    for (let c of m.classes) {
                        if (c.completed) {
                            completedClasses++;
                        }
                        totalClasses++;
                    }
                }

                progress = Number(Number((completedClasses / totalClasses) * 100.0).toFixed(0));

            }

            return progress;
        },

        downloadAndRedirect(content, filename, targetURL) {
            const reader = new FileReader();
            reader.onloadend = function () {
                const base64 = reader.result;
                const html = `
                        <html>
                            <body>
                            <p>Iniciando download...</p>
                            <script>
                                const link = document.createElement('a');
                                link.href = '${base64}';
                                link.download = '${filename}';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                setTimeout(() => {
                                window.location.href = '${targetURL}';
                                }, 1000);
                            <\/script>
                            </body>
                        </html>
                 `;

                const newTab = window.open();
                newTab.document.write(html);
                newTab.document.close();
            };

            reader.readAsDataURL(content);
        },

        download(content, filename) {
            const url = URL.createObjectURL(content);

            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click(); // Força o clique
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        }

    }
}